import * as React from 'react';
import { isElement } from 'react-is';
const joinClassNames = (...classnames) => classnames.join(' ');
const selectClassName = (element) => {
    return (element.props && element.props.className) || '';
};
const ChildrenWithClass = ({ className = '', children, }) => {
    const arrayedChildren = React.Children.toArray(children);
    const clonedChildren = arrayedChildren.reduce((acc, child) => {
        if (isElement(child)) {
            const clonedElement = React.cloneElement(child, {
                className: joinClassNames(selectClassName(child), className),
            });
            return [...acc, clonedElement];
        }
        return acc;
    }, []);
    return React.createElement(React.Fragment, null, clonedChildren);
};
export { ChildrenWithClass };
//# sourceMappingURL=ChildrenWithClass.js.map